"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var modalWithHeaderStyles = makeStyles_1.default(function (theme) {
    var _a;
    return ({
        modalRoot: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                minWidth: '60vw',
            },
            _a.width = '100%',
            _a[theme.breakpoints.up('md')] = {
                maxWidth: '600px',
            },
            _a),
        closeContainer: {
            color: theme.palette.common.white,
            zIndex: 100,
            backgroundColor: theme.palette.background.header,
            display: 'flex',
            justifyContent: 'space-between',
            padding: 0,
        },
        title: {
            lineHeight: '33px',
            display: 'inline-block',
            padding: '16px',
            color: theme.palette.common.white,
        },
        closeButton: {
            height: '25px',
            width: '25px',
            cursor: 'pointer',
            textAlign: 'right',
            margin: '8px',
        },
        icon: {
            width: '100%',
            height: '100%',
            fill: theme.palette.primary.main,
        },
    });
}, { name: 'Checkout_ModalWithHeader' });
exports.default = modalWithHeaderStyles;
